import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoProps {
    tone?: 'dark' | 'light'
    className?: string
}

export const LogoMark: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    const frame = tone === 'dark' ? 'fill-primary' : 'fill-ink-foreground'
    const pane = tone === 'dark' ? 'fill-background' : 'fill-ink'

    return (
        <svg viewBox='0 0 32 32' aria-hidden='true' className={cn('size-8 shrink-0', className)}>
            <rect width='32' height='32' rx='7' className={frame} />
            <rect x='7' y='7' width='8.5' height='8.5' rx='1.5' className={pane} />
            <rect x='16.5' y='7' width='8.5' height='8.5' rx='1.5' className='fill-brand' />
            <rect x='7' y='16.5' width='8.5' height='8.5' rx='1.5' className={pane} />
            <rect x='16.5' y='16.5' width='8.5' height='8.5' rx='1.5' className={pane} />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark tone={tone} />

            <span className={cn('font-heading text-lg font-semibold tracking-[0.22em]', tone === 'dark' ? 'text-foreground' : 'text-ink-foreground')}>
                {siteConfig.name}
            </span>
        </span>
    )
}
